module.exports = __webpack_public_path__ + "assets/img/my-photo.44acfe1d.png";